import { Icon } from "@iconify/react/dist/iconify.js";
import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const Thankyou =()=>{
    return(
        <>
        <Helmet>
            <title>Thank-You - eYantra</title>
        </Helmet>
            <div className="container-fluid d-flex align-items-center" id="thankyouBg" style={{
                backgroundImage: 'url(./assests/thankyouBg.png)',
                minHeight: '100vh',
                backgroundSize: "cover",
                backgroundPosition: "center",
            }}>
             <Container className="p-md-5 p-3 my-4">
                <Row className="text-start">
                    <Col md={7} className="">
                        <h2 className="textGreen fs-92 fw-bold" >Thank you</h2>
                        <p className="fs-18 fs-md-32">
                        for choosing eYantra,
                        <br></br>we'll get back to you right away.
                        </p>
                        <Link to="/">
                        <Button id="btnCTA" className="w-25 w-md-25">
                            <span className="d-flex align-items-center justify-content-around">
                        <Icon icon="iconoir:home" width="24" height="24" className=""  style={{color: "#ffffff"}} /> 
                            Home
                        </span>
                        </Button>
                        </Link>
                    </Col>

                </Row>

             </Container>
             </div>        
        </>
    )
}

export default Thankyou;